// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./consultationDetails.scss";
import DeleteIcon from "../../../assets/delete_icon_pre.svg";
// project file imports(UI components) ⇒
import CustomSelect from "../../UI Component/CustomSelect/CustomSelect";
import ProcedureCancelledUI from "./ProcedureCancelledUI";

const ConsultationDetails = (props) => {
  const {
    appointmentDetails,
    procedureDetails,
    consultationOptions,
    addNewProcedure,
    deleteProcedure,
    handleConsultationType,
    applyRefund,
    applyDiscount,
    applyFee,
    applyDefaultFee,
    applyDefaultDiscount,
    applyDefaultRefund,
  } = props;

  // Helper methods ⇒
  const renderConsultationType = (
    appointmentType,
    consultationType,
    procedureName
  ) => {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (consultationType) {
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{procedureName}</span>;
      case "instant":
        return <span>Instant</span>;
      default:
        return "";
    }
  };

  // create UI ⇒

  const displayCancelledText = () => {
    return <ProcedureCancelledUI />;
  };
  const getConsultationLabel = (procedurePerRow) => {
    const procedureName = procedurePerRow.procedure_name;
    const consultationName = procedurePerRow.consultation_name;

    let labelToFind = "";

    if (procedureName) {
      if (procedureName.includes("followup")) {
        labelToFind = "In-clinic Follow-up";
      } else if (procedureName.includes("regular")) {
        labelToFind = "In-clinic Regular";
      } else {
        labelToFind = procedureName;
      }
    } else if (consultationName) {
      if (consultationName.includes("followup")) {
        labelToFind = "In-clinic Follow-up";
      } else if (consultationName.includes("regular")) {
        labelToFind = "In-clinic Regular";
      }
    }

    return labelToFind;
  };

  const getConsultationValue = (procedurePerRow) => {
    const labelToFind = getConsultationLabel(procedurePerRow);
    return consultationOptions.find((option) => option.label === labelToFind);
  };
  const consultationDetailsUI = () => {
    return (
      <div className="consultation-details-container">
        <div className="row info m-0 mb-2">
          <div className="col-12 mb-2 mt-2 info-header">
            CONSULTATION DETAILS
          </div>
          <div className="col-12 mb-2 accordian_css_desktop">
            <div className="consultion_header">
              <div className="col_item consultion_heading_name">Procedure</div>
              <div className="col_item">Fee</div>
              <div className="col_item" style={{ minWidth: "90px" }}>
                Partial Fee
              </div>
              <div className="col_item" style={{ minWidth: "70px" }}>
                Subtotal
              </div>
              <div className="col_item" style={{ minWidth: "75px" }}>
                Discount
              </div>
              <div className="col_item">Refund</div>
              <div className="col_item">IGST</div>
              <div className="col_item">CGST</div>
              <div className="col_item">SGST</div>
              <div className="col_item" style={{ minWidth: "92px" }}>
                Final Amount
              </div>
              <div className="col_item">Paid</div>
              <div className="col_item">Pending</div>
            </div>
            {appointmentDetails?.map((appointment, index) => (
              <div className="consultation-details-value-container" key={index}>
                <div className="d-flex ai-center">
                  <div
                    className="col_item consultion_heading_name select_style"
                    style={{ paddingRight: "20px" }}
                  >
                    {appointment.payment_method ===
                    "Paid at Clinic - By Cash" ? (
                      <div className="default_procedure">
                        <span
                          style={{
                            padding: "2px 8px",
                            width: "80%",
                            opacity: "0.7",
                            color: "rgb(153, 153, 153)",
                          }}
                        >
                          {renderConsultationType(
                            appointment.appointment_type,
                            appointment.consultation_type,
                            appointment.procedure_name
                          )}
                        </span>
                        <div className="separator">
                          <span className="react-select__indicator-separator css-1okebmr-indicatorSeparator"></span>
                          <div
                            class="react-select__indicator react-select__dropdown-indicator css-tlfecz-indicatorContainer"
                            aria-hidden="true"
                            style={{
                              padding: "5px",
                              paddingLeft: "10px",
                            }}
                          >
                            <i
                              className="fa fa-caret-down"
                              style={{ color: "hsl(0, 0%, 70%)" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    ) : (
                      renderConsultationType(
                        appointment.appointment_type,
                        appointment.consultation_type,
                        appointment.procedure_name
                      )
                    )}
                  </div>
                  <div
                    className={
                      "col_item " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                  >
                    {appointment.payment_method ===
                    "Paid at Clinic - By Cash" ? (
                      <input
                        type="tell"
                        min="0"
                        max="100"
                        onKeyPress={(event) => {
                          if (!/\d/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        className="discount_input"
                        value={appointment.fee_in_rupees}
                        placeholder="0"
                        onChange={(e) => applyDefaultFee(e, index)}
                        autoComplete="off"
                        disabled={appointment.is_deleted}
                      />
                    ) : (
                      <div>
                        <span>₹</span>
                        {appointment?.fee_in_rupees == null
                          ? 0
                          : appointment.fee_in_rupees}
                      </div>
                    )}
                  </div>
                  <div
                    className={
                      "col_item " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                    style={{ minWidth: "90px" }}
                  >
                    {appointment?.partial_with_convenience_fee == null ? (
                      0
                    ) : (
                      <span>
                        {appointment?.partial_with_convenience_fee ?? 0}
                      </span>
                    )}
                  </div>
                  <div
                    className={
                      "col_item " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                    style={{ minWidth: "70px" }}
                  >
                    <span>₹</span>
                    {appointment?.subtotal_in_rupees == null
                      ? 0
                      : appointment.subtotal_in_rupees}
                  </div>
                  <div
                    className={
                      "col_item " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                    style={{ minWidth: "75px" }}
                  >
                    {appointment.payment_method ===
                    "Paid at Clinic - By Cash" ? (
                      <div class="percentInput">
                        <input
                          type="tell"
                          maxlength="4"
                          min="0"
                          max="100"
                          onKeyPress={(event) => {
                            if (!/\d/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          className="discount_input"
                          value={appointment.discount_percent}
                          placeholder="0"
                          onChange={(e) => applyDefaultDiscount(e, index)}
                          autoComplete="off"
                          disabled={appointment.is_deleted}
                        />
                        <span>%</span>
                      </div>
                    ) : (
                      <span>
                        {appointment?.discount_percent == null
                          ? 0 + "%"
                          : appointment.discount_percent + "%"}
                      </span>
                    )}
                  </div>
                  <div
                    className={
                      "col_item " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                  >
                    {appointment.payment_method ===
                    "Paid at Clinic - By Cash" ? (
                      <input
                        type="tell"
                        min="0"
                        max="100"
                        onKeyPress={(event) => {
                          if (!/\d/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        className="discount_input"
                        value={appointment.refund_in_rupees}
                        placeholder="0"
                        onChange={(e) => applyDefaultRefund(e, index)}
                        autoComplete="off"
                        disabled={appointment.is_deleted}
                      />
                    ) : (
                      appointment.refund_in_rupees
                    )}
                  </div>
                  <div
                    className={
                      "col_item " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                  >
                    {appointment?.igst_percent == null ? (
                      0
                    ) : (
                      <span>
                        {appointment.igst_percent}
                        {appointment.igst_percent ? "%" : ""}
                      </span>
                    )}
                  </div>
                  <div
                    className={
                      "col_item " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                  >
                    {appointment?.cgst_percent == null ? (
                      0
                    ) : (
                      <span>
                        {appointment.cgst_percent}
                        {appointment.cgst_percent ? "%" : ""}
                      </span>
                    )}
                  </div>
                  <div
                    className={
                      "col_item " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                  >
                    {appointment?.sgst_percent == null ? (
                      0
                    ) : (
                      <span>
                        {appointment.sgst_percent}
                        {appointment.sgst_percent ? "%" : ""}
                      </span>
                    )}
                  </div>

                  <div
                    className={
                      "col_item total_amount_css " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                    style={{ minWidth: "92px" }}
                  >
                    <span>₹</span>
                    {appointment?.final_amount_in_rupees}
                  </div>
                  <div
                    className={
                      "col_item total_amount_css " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                  >
                    <span>₹</span>
                    {appointment?.paid_amount ? appointment?.paid_amount : 0}
                  </div>
                  <div
                    className={
                      "col_item total_amount_css " +
                      (appointment.is_deleted
                        ? "consultation-details-disabled"
                        : "")
                    }
                  >
                    <span>₹</span>

                    {appointment?.pending_amount
                      ? appointment?.pending_amount
                      : 0}
                  </div>
                </div>
                {appointment.is_deleted && displayCancelledText()}
              </div>
            ))}

            {procedureDetails?.map((procedurePerRow, index) => {
              if (procedurePerRow) {
                return (
                  <div
                    className="consultation-details-value-container"
                    key={index}
                  >
                    <div className="d-flex ai-center slected_consultion_body">
                      <div className="col_item consultion_heading_name">
                        <CustomSelect
                          className="select_style"
                          showSearch={true}
                          placeholder=""
                          value={getConsultationValue(procedurePerRow)}
                          options={consultationOptions}
                          handleChange={(opt) =>
                            handleConsultationType(opt, index)
                          }
                          fixedBottomBtn={false}
                          isSearchable={false}
                          isDisabled={procedurePerRow.is_deleted}
                        />
                      </div>
                      <div
                        className={
                          "col_item " +
                          (procedurePerRow.is_deleted
                            ? "consultation-details-disabled"
                            : "")
                        }
                      >
                        {procedurePerRow.consultation_name === "" ? (
                          0
                        ) : (
                          <input
                            type="tell"
                            min="0"
                            max="100"
                            onKeyPress={(event) => {
                              if (!/\d/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            className="discount_input"
                            column={index + 1}
                            value={procedurePerRow.fee_in_rupees}
                            index={index}
                            placeholder="0"
                            onChange={(e) => applyFee(e, index)}
                            autoComplete="off"
                            disabled={procedurePerRow.is_deleted}
                          />
                        )}
                      </div>
                      <div
                        className={
                          "col_item " +
                          (procedurePerRow.is_deleted
                            ? "consultation-details-disabled"
                            : "")
                        }
                        style={{ minWidth: "90px" }}
                      >
                        {procedurePerRow?.partial_with_convenience_fee ?? 0}
                      </div>
                      <div
                        className={
                          "col_item " +
                          (procedurePerRow.is_deleted
                            ? "consultation-details-disabled"
                            : "")
                        }
                        style={{ minWidth: "70px" }}
                      >
                        <span>₹</span>
                        {procedurePerRow.subtotal_in_rupees
                          ? procedurePerRow.subtotal_in_rupees
                          : 0}
                      </div>
                      <div
                        className={
                          "col_item " +
                          (procedurePerRow.is_deleted
                            ? "consultation-details-disabled"
                            : "")
                        }
                        key={index}
                        style={{ minWidth: "75px" }}
                      >
                        {procedurePerRow.consultation_name === "" ? (
                          0
                        ) : (
                          <div class="percentInput">
                            <input
                              type="tell"
                              maxlength="4"
                              min="0"
                              max="100"
                              onKeyPress={(event) => {
                                if (!/\d/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              className="discount_input"
                              column={index + 1}
                              value={
                                procedurePerRow?.discount_percent == null
                                  ? 0
                                  : procedurePerRow.discount_percent
                              }
                              index={index}
                              placeholder="0"
                              onChange={(e) => applyDiscount(e, index)}
                              autoComplete="off"
                              disabled={procedurePerRow.is_deleted}
                            />
                            <span>%</span>
                          </div>
                        )}
                      </div>
                      <div
                        className={
                          "col_item " +
                          (procedurePerRow.is_deleted
                            ? "consultation-details-disabled"
                            : "")
                        }
                      >
                        {procedurePerRow.consultation_name === "" ? (
                          0
                        ) : (
                          <input
                            type="tell"
                            min="0"
                            max="100"
                            onKeyPress={(event) => {
                              if (!/\d/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            className="discount_input"
                            column={index + 1}
                            value={
                              procedurePerRow?.refund_in_rupees == null
                                ? 0
                                : procedurePerRow.refund_in_rupees
                            }
                            index={index}
                            placeholder="0"
                            onChange={(e) => applyRefund(e, index)}
                            autoComplete="off"
                            disabled={procedurePerRow.is_deleted}
                          />
                        )}
                      </div>
                      <div
                        className={
                          "col_item " +
                          (procedurePerRow.is_deleted
                            ? "consultation-details-disabled"
                            : "")
                        }
                      >
                        {procedurePerRow.igst_percent}
                        {procedurePerRow.igst_percent &&
                        procedurePerRow.igst_percent !== 0 ? (
                          <span>%</span>
                        ) : null}
                      </div>
                      <div
                        className={
                          "col_item " +
                          (procedurePerRow.is_deleted
                            ? "consultation-details-disabled"
                            : "")
                        }
                      >
                        {procedurePerRow.cgst_percent}
                        {procedurePerRow.cgst_percent &&
                        procedurePerRow.cgst_percent !== 0 ? (
                          <span>%</span>
                        ) : null}
                      </div>
                      <div
                        className={
                          "col_item " +
                          (procedurePerRow.is_deleted
                            ? "consultation-details-disabled"
                            : "")
                        }
                      >
                        {procedurePerRow.sgst_percent}
                        {procedurePerRow.sgst_percent &&
                        procedurePerRow.sgst_percent !== 0 ? (
                          <span>%</span>
                        ) : null}
                      </div>

                      <div
                        className="col_item total_amount_css"
                        style={{ minWidth: "92px", maxWidth: "92px" }}
                      >
                        <span
                          style={{ flex: "1" }}
                          className={
                            "total-amount " +
                            (procedurePerRow.is_deleted
                              ? "consultation-details-disabled"
                              : "")
                          }
                        >
                          <span>₹</span>
                          {procedurePerRow.final_amount_in_rupees
                            ? procedurePerRow.final_amount_in_rupees
                            : 0}
                        </span>
                        {/* {!procedurePerRow.is_deleted && (
                          <span
                            onClick={() => deleteProcedure(index)}
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={DeleteIcon}
                              alt=""
                              style={{ width: "16px" }}
                            />
                          </span>
                        )} */}
                      </div>
                      <div className="col_item total_amount_css">
                        <span>₹</span>
                        {procedurePerRow?.paid_amount
                          ? procedurePerRow?.paid_amount
                          : 0}
                      </div>
                      <div className="col_item total_amount_css">
                        <span>₹</span>
                        <span>
                          {procedurePerRow?.pending_amount
                            ? procedurePerRow?.pending_amount
                            : 0}
                        </span>
                        {!procedurePerRow.is_deleted && (
                          <span>
                            <img
                              onClick={() => deleteProcedure(index)}
                              src={DeleteIcon}
                              alt=""
                              style={{
                                width: "16px",
                                marginLeft: "20px",
                                cursor: "pointer",
                              }}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                    {procedurePerRow.is_deleted && displayCancelledText()}
                  </div>
                );
              }
            })}
            <div className="add_procedure">
              <span onClick={addNewProcedure}>+ Add Procedure</span>
            </div>
          </div>

          <div className="col-12 mb-2 accordian_css_mobile">
            <div id="accordion" className="col-12 accordion p-0">
              {appointmentDetails?.map((appointment, index) => (
                <div key={index}>
                  <div className="card-container">
                    <div
                      className={`card-header ${
                        procedureDetails.length <= 1 ? "" : "collapsed"
                      }`}
                      data-toggle="collapse"
                      href={`#in_clinic_regular_${index}`}
                    >
                      <span className="circle_plus_minus"></span>
                      {appointment.payment_method ===
                      "Paid at Clinic - By Cash" ? (
                        <div>
                          <p className="cc-procedure-title">Procedure</p>
                          <div
                            className="default_procedure"
                            style={{ marginRight: "90px", marginLeft: "6px" }}
                          >
                            <span
                              className="card-title"
                              style={{
                                padding: "2px 8px",
                                width: "80%",
                                color: "rgba(0, 0, 0, 0.6)",
                              }}
                            >
                              {renderConsultationType(
                                appointment.appointment_type,
                                appointment.consultation_type,
                                appointment.procedure_name
                              )}
                            </span>
                            <div className="separator">
                              <span className="react-select__indicator-separator css-1okebmr-indicatorSeparator"></span>
                              <div
                                class="react-select__indicator react-select__dropdown-indicator css-tlfecz-indicatorContainer"
                                aria-hidden="true"
                                style={{
                                  padding: "5px",
                                  paddingLeft: "10px",
                                }}
                              >
                                <i
                                  className="fa fa-caret-down"
                                  style={{ color: "hsl(0, 0%, 70%)" }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <p className="cc-procedure-header">Procedure</p>
                          <a className="card-title">
                            {renderConsultationType(
                              appointment.appointment_type,
                              appointment.consultation_type,
                              appointment.procedure_name
                            )}
                          </a>
                        </div>
                      )}
                    </div>
                    <div
                      id={`in_clinic_regular_${index}`}
                      className={`card-body collapse ${
                        procedureDetails.length <= 1 ? "show" : ""
                      }`}
                      data-parent="#accordion"
                    >
                      <div className="tab_content_top">
                        <div className="consultion_header">
                          <div className="col_item">Fee</div>
                          <div className="col_item">Partial Fee</div>
                          <div className="col_item">Subtotal</div>
                          <div className="col_item">Discount</div>
                          <div className="col_item">Refund</div>
                        </div>
                        <div className="consultation-details-value-container d-flex ai-center">
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment.payment_method ===
                            "Paid at Clinic - By Cash" ? (
                              <input
                                type="tell"
                                min="0"
                                max="100"
                                onKeyPress={(event) => {
                                  if (!/\d/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                className="discount_input"
                                value={appointment.fee_in_rupees}
                                placeholder="0"
                                onChange={(e) => applyDefaultFee(e, index)}
                                autoComplete="off"
                                disabled={appointment.is_deleted}
                              />
                            ) : (
                              <div>
                                <span>₹</span>
                                {appointment?.fee_in_rupees == null
                                  ? 0
                                  : appointment.fee_in_rupees}
                              </div>
                            )}
                          </div>
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment?.partial_with_convenience_fee ==
                            null ? (
                              0
                            ) : (
                              <span>
                                {appointment?.partial_with_convenience_fee ?? 0}
                              </span>
                            )}
                          </div>

                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment?.subtotal_in_rupees == null
                              ? 0
                              : appointment.subtotal_in_rupees}
                          </div>

                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment.payment_method ===
                            "Paid at Clinic - By Cash" ? (
                              <div class="percentInput">
                                <input
                                  type="tell"
                                  maxlength="4"
                                  min="0"
                                  max="100"
                                  onKeyPress={(event) => {
                                    if (!/\d/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  className="discount_input"
                                  value={appointment.discount_percent}
                                  placeholder="0"
                                  onChange={(e) =>
                                    applyDefaultDiscount(e, index)
                                  }
                                  autoComplete="off"
                                  disabled={appointment.is_deleted}
                                />
                                <span>%</span>
                              </div>
                            ) : (
                              <span>
                                {appointment?.discount_percent == null
                                  ? 0 + "%"
                                  : appointment.discount_percent + "%"}
                              </span>
                            )}
                          </div>
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment.payment_method ===
                            "Paid at Clinic - By Cash" ? (
                              <input
                                type="tell"
                                min="0"
                                max="100"
                                onKeyPress={(event) => {
                                  if (!/\d/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                className="discount_input"
                                value={appointment.refund_in_rupees}
                                placeholder="0"
                                onChange={(e) => applyDefaultRefund(e, index)}
                                autoComplete="off"
                                disabled={appointment.is_deleted}
                              />
                            ) : (
                              appointment.refund_in_rupees
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="tab_content_middle">
                        <div className="consultion_header">
                          <div className="col_item">IGST</div>
                          <div className="col_item">CGST</div>
                          <div className="col_item">SGST</div>
                          <div className="col_item">F.Amount</div>
                        </div>
                        <div className="consultation-details-value-container d-flex ai-center">
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment?.igst_percent == null ? (
                              0
                            ) : (
                              <span>
                                {appointment.igst_percent}
                                {appointment.igst_percent ? "%" : ""}
                              </span>
                            )}
                          </div>
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment?.cgst_percent == null ? (
                              0
                            ) : (
                              <span>
                                {appointment.cgst_percent}
                                {appointment.cgst_percent ? "%" : ""}
                              </span>
                            )}
                          </div>
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            {appointment?.sgst_percent == null ? (
                              0
                            ) : (
                              <span>
                                {appointment.sgst_percent}
                                {appointment.sgst_percent ? "%" : ""}
                              </span>
                            )}
                          </div>
                          <div
                            className={
                              "col_item total_amount_css " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment.final_amount_in_rupees}
                          </div>
                        </div>
                      </div>
                      <div className="tab_content_middle">
                        <div className="consultion_header">
                          <div className="col_item-paid">Paid</div>
                          <div className="col_item-paid">Pending</div>
                        </div>
                        <div className="consultation-details-value-container d-flex ai-center">
                          <div
                            className={
                              "col_item-paid total_amount_css " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment?.paid_amount
                              ? appointment?.paid_amount
                              : 0}
                          </div>
                          <div
                            className={
                              "col_item-paid total_amount_css " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment?.pending_amount
                              ? appointment?.pending_amount
                              : 0}
                          </div>
                        </div>
                      </div>
                      <div className="tab_content_bottom">
                        <div className="consultion_header">
                          <div className="col_item">Total</div>
                        </div>
                        <div className="consultation-details-value-container d-flex ai-center">
                          <div
                            className={
                              "col_item " +
                              (appointment.is_deleted
                                ? "consultation-details-disabled"
                                : "")
                            }
                          >
                            <span>₹</span>
                            {appointment.total_fee_in_rupees}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {appointment.is_deleted && displayCancelledText()}
                </div>
              ))}
              {procedureDetails?.map((procedurePerRow, index) => {
                if (procedurePerRow) {
                  return (
                    <div key={index}>
                      <div className="card-container">
                        <div
                          className="card-header"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href={`#slected_procedure_${index}`}
                        >
                          <span className="circle_plus_minus"></span>
                          <div className="cc-card-select">
                            <p className="cc-procedure-title">Procedure</p>

                            <a
                              className="card-title"
                              style={{
                                paddingRight: "76px",
                                marginLeft: "6px",
                              }}
                            >
                              <CustomSelect
                                className="select_style"
                                showSearch={true}
                                placeholder=""
                                value={consultationOptions.filter((option) => {
                                  return (
                                    option.label ===
                                    (procedurePerRow.procedure_name
                                      ? procedurePerRow.procedure_name.includes(
                                          "followup"
                                        )
                                        ? "In-clinic Follow-up"
                                        : procedurePerRow.procedure_name.includes(
                                            "regular"
                                          )
                                        ? "In-clinic Regular"
                                        : procedurePerRow.procedure_name
                                      : procedurePerRow.consultation_name.includes(
                                          "followup"
                                        )
                                      ? "In-clinic Follow-up"
                                      : procedurePerRow.consultation_name.includes(
                                          "regular"
                                        )
                                      ? "In-clinic Regular"
                                      : "")
                                  );
                                })}
                                options={consultationOptions}
                                handleChange={(opt) =>
                                  handleConsultationType(opt, index)
                                }
                                fixedBottomBtn={false}
                                isSearchable={false}
                                isDisabled={procedurePerRow.is_deleted}
                              />
                            </a>
                          </div>
                          {!procedurePerRow.is_deleted && (
                            <span
                              onClick={() => deleteProcedure(index)}
                              style={{ cursor: "pointer" }}
                            >
                              <img src={DeleteIcon} alt="" />
                            </span>
                          )}
                        </div>
                        <div
                          id={`slected_procedure_${index}`}
                          className="card-body collapse show"
                          data-parent="#accordion"
                        >
                          <div className="tab_content_top">
                            <div className="consultion_header">
                              <div className="col_item">Fee</div>
                              <div className="col_item">Subtotal</div>
                              <div className="col_item">Discount</div>
                              <div className="col_item">Refund</div>
                            </div>
                            <div className="consultation-details-value-container d-flex ai-center">
                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow.consultation_name === "" ? (
                                  0
                                ) : (
                                  <input
                                    type="tell"
                                    min="0"
                                    max="100"
                                    onKeyPress={(event) => {
                                      if (!/\d/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    className="discount_input"
                                    column={index + 1}
                                    value={procedurePerRow.fee_in_rupees}
                                    index={index}
                                    placeholder="0"
                                    onChange={(e) => applyFee(e, index)}
                                    autoComplete="off"
                                    disabled={procedurePerRow.is_deleted}
                                  />
                                )}
                              </div>
                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow.subtotal_in_rupees
                                  ? procedurePerRow.subtotal_in_rupees
                                  : 0}
                              </div>

                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                                key={index}
                              >
                                {procedurePerRow.consultation_name === "" ? (
                                  0 + "%"
                                ) : (
                                  <input
                                    type="tell"
                                    maxlength="4"
                                    min="0"
                                    max="100"
                                    onKeyPress={(event) => {
                                      if (!/\d/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    className="discount_input"
                                    column={index + 1}
                                    value={
                                      procedurePerRow?.discount_percent == null
                                        ? 0 + "%"
                                        : procedurePerRow.discount_percent + "%"
                                    }
                                    index={index}
                                    placeholder="0"
                                    onChange={(e) => applyDiscount(e, index)}
                                    autoComplete="off"
                                    style={{ maxWidth: "60px" }}
                                    disabled={procedurePerRow.is_deleted}
                                  />
                                )}
                              </div>

                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                {procedurePerRow.consultation_name === "" ? (
                                  0
                                ) : (
                                  <input
                                    type="tell"
                                    min="0"
                                    max="100"
                                    onKeyPress={(event) => {
                                      if (!/\d/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    className="discount_input"
                                    column={index + 1}
                                    value={
                                      procedurePerRow?.refund_in_rupees == null
                                        ? 0
                                        : procedurePerRow.refund_in_rupees
                                    }
                                    index={index}
                                    placeholder="0"
                                    onChange={(e) => applyRefund(e, index)}
                                    autoComplete="off"
                                    disabled={procedurePerRow.is_deleted}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="tab_content_middle">
                            <div className="consultion_header">
                              <div className="col_item">IGST</div>
                              <div className="col_item">CGST</div>
                              <div className="col_item">SGST</div>
                              <div className="col_item">F.Amount</div>
                            </div>
                            <div className="consultation-details-value-container d-flex ai-center">
                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                {procedurePerRow.igst_percent}
                                {procedurePerRow.igst_percent &&
                                procedurePerRow.igst_percent !== 0 ? (
                                  <span>%</span>
                                ) : null}
                              </div>

                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                {procedurePerRow.cgst_percent}
                                {procedurePerRow.cgst_percent &&
                                procedurePerRow.cgst_percent !== 0 ? (
                                  <span>%</span>
                                ) : null}
                              </div>

                              <div
                                className={
                                  "col_item " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                {procedurePerRow.sgst_percent}
                                {procedurePerRow.sgst_percent &&
                                procedurePerRow.sgst_percent !== 0 ? (
                                  <span>%</span>
                                ) : null}
                              </div>

                              <div
                                className={
                                  "col_item total_amount_css " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow.final_amount_in_rupees
                                  ? procedurePerRow.final_amount_in_rupees
                                  : 0}
                              </div>
                            </div>
                          </div>
                          <div className="tab_content_middle">
                            <div className="consultion_header">
                              <div className="col_item-paid">Paid</div>
                              <div className="col_item-paid">Pending</div>
                            </div>
                            <div className="consultation-details-value-container d-flex ai-center">
                              <div
                                className={
                                  "col_item-paid " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow?.paid_amount
                                  ? procedurePerRow?.paid_amount
                                  : 0}
                              </div>
                              <div
                                className={
                                  "col_item-paid total_amount_css " +
                                  (procedurePerRow.is_deleted
                                    ? "consultation-details-disabled"
                                    : "")
                                }
                              >
                                <span>₹</span>
                                {procedurePerRow?.pending_amount
                                  ? procedurePerRow?.pending_amount
                                  : 0}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {procedurePerRow.is_deleted && displayCancelledText()}
                    </div>
                  );
                }
              })}
            </div>
            <div className="add_procedure">
              <span onClick={addNewProcedure}>+ Add Procedure</span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return <>{consultationDetailsUI()}</>;
};
//export
export default ConsultationDetails;
